import React from "react";
import { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminTable from "../Helpers/AdminTable";
import { useState } from "react";
import { personalTrainingsAction } from "src/store/Slices/Administrator/PersonalTrainingsSlice";
import SureModal from "src/components/Modals/SureModal";
import dayjs from "dayjs";
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable";

const PersonalTrainings = ({ mnemo }) => {
    const dispatch = useDispatch();
    const searchInput = useRef(null);

    const items = [
        {
            key: "1",
            label: "Удалить",
            onClick: () => {
                setIsOpenDeleteModal(true);
            },
            disabled: !mnemo?.children?.find((el) => el.mnemo === "deleteBtn"),
        },
    ];

    const filterOptionsArr = [
        { label: "Фильрация", value: 0, index: undefined },
        {
            label: "По номеру",
            value: 1,
            index: "id",
            title: "Персональная тренировка",
        },
        { label: "По клиенту", value: 2, index: "user", title: "Пользователь" },
        {
            label: "По дате записи",
            value: 3,
            index: "docDate",
            title: "Дата записи",
        },
        { label: "По клубу", value: 4, index: "club", title: "Клуб" },
        {
            label: "По проведению",
            value: 5,
            index: "isCommit",
            title: "Проведено",
        },
        { label: "По оплате", value: 6, index: "isPay", title: "Оплачено" },
        { label: "По цене", value: 7, index: "price", title: "Цена" },
        { label: "По занятию", value: 8, index: "job", title: "Занятие" },
        { label: "По услуге", value: 9, index: "service", title: "Услуга" },
        { label: "По № набора", value: 10, index: "packId", title: "№ набора" },
        { label: "По оценке", value: 11, index: "userStar", title: "Оценка" },
    ];

    const [isDeleted, setIsDeleted] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [personalTrainingsInfo, setPersonalTrainingsInfo] = useState();
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
    // STORE
    const personalTrainingsList = useSelector(
        (state) => state.PersonalTrainingsSlice.personalTrainingsList
    );
    const personalTrainingsListLoading = useSelector(
        (state) => state.PersonalTrainingsSlice.personalTrainingsListLoading
    );

    const onClickDelete = () => {
        dispatch(
            personalTrainingsAction({
                flag: "delete",
                value: { id: personalTrainingsInfo.id },
            })
        ).then(() => {
            dispatch(personalTrainingsAction({ flag: "get" }));
            setIsOpenDeleteModal(false);
        });
        setPage(1);
        setPageSize(20);
    };

    const searchItemsMap = (keys, values) => {
        const formattedItems = {};
        if (keys && values) {
            keys.forEach((key, index) => {
                if (values[index] && values[index][0]) {
                    if (key === "id") {
                        formattedItems["Id.From"] = values[index][0];
                        formattedItems["Id.To"] = values[index][1];
                    } else if (key === "price") {
                        formattedItems["price.From"] = values[index][0];
                        formattedItems["price.To"] = values[index][1];
                    } else if (key === "docDate") {
                        formattedItems["DocDate.From"] = values[index][0];
                        formattedItems["DocDate.To"] = values[index][1];
                    } else if (key === "employ") {
                        formattedItems["employId"] = values[index][0];
                    } else if (key === "service") {
                        formattedItems["ServiceId"] = values[index][0];
                    } else if (key === "club") {
                        formattedItems["ClubId"] = values[index][0];
                    } else {
                        formattedItems[key] = values[index][0];
                    }
                }
            });
            return formattedItems;
        }
    };
    const formattedPerTrRows = useMemo(() => {
        return personalTrainingsList?.data?.value?.rows.map((item) => ({
            ...item,
            docDate: dayjs(item.docDate).format("YYYY-MM-DD"),
        }));
    }, [personalTrainingsList]);

    const handleTableChange = (pagination, filters, sorter) => {
        const payload = searchItemsMap(
            Object.keys(filters),
            Object.values(filters)
        );
        dispatch(
            personalTrainingsAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    count: pagination.pageSize,
                    offset: pagination.pageSize * (pagination.current - 1),
                    orderBy: sorter?.column?.dataIndex,
                    isDesc: sorter.order
                        ? sorter.order === "ascend"
                            ? true
                            : false
                        : undefined,
                    ...payload,
                },
            })
        );
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const clickOnAction = (element) => {
        setPersonalTrainingsInfo(element);
    };

    const handlePaginationChange = (page, pageSize) => {
        dispatch(
            personalTrainingsAction({
                flag: "get",
                value: {
                    count: pageSize,
                    offset: pageSize * (page - 1),
                },
            })
        );
        setPage(page);
        setPageSize(pageSize);
    };

    const onClickSearchItem = (selectedKeys, dataIndex) => {
        setPage(1);
        setPageSize(20);
        dispatch(
            personalTrainingsAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    [`${dataIndex}`]: selectedKeys[0],
                },
            })
        );
    };

    useEffect(() => {
        dispatch(personalTrainingsAction({ flag: "get" }));
    }, []);

    //   const showDeletedItems = (value) => {
    //     setIsDeleted(value);
    //     dispatch(
    //       personalTrainingsAction({ flag: "get", value: { isDeleted: value } })
    //     );
    //     setPage(1);
    //     setPageSize(20);
    //   };

    return (
        <>
            <SureModal
                visible={isOpenDeleteModal}
                setVisible={setIsOpenDeleteModal}
                onClickYes={onClickDelete}
            />
            {window.innerWidth >= 768 ? (
                <AdminTable
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    onChange={handleTableChange}
                    loading={personalTrainingsListLoading}
                    onClickRowOne={(record) => {
                        setPersonalTrainingsInfo(record);
                    }}
                    columns={personalTrainingsList}
                    rows={formattedPerTrRows}
                    total={personalTrainingsList?.data?.value?.totalCount}
                    //   title={() => (
                    //     <TableTitle
                    //       isDeleted={isDeleted}
                    //       showDeletedItems={showDeletedItems}
                    //       onClickOpenModal={() => {
                    //         setIsOpenAddEditModal({ open: true, flag: "add" });
                    //       }}
                    //       mnemoButton={
                    //         !mnemo?.children?.find((el) => el.mnemo === "insertBtn")
                    //       }
                    //       mnemoSwitcher={
                    //         !mnemo?.children?.find((el) => el.mnemo === "isDeletedBtn")
                    //       }
                    //     />
                    //   )}
                    items={items}
                    isDeleted={isDeleted}
                />
            ) : (
                <AntdMobileTable
                    items={items}
                    page={page}
                    setPage={setPage}
                    setPageSize={setPageSize}
                    elementsList={personalTrainingsList}
                    elementsListLoading={personalTrainingsListLoading}
                    handlePaginationChange={handlePaginationChange}
                    clickOnAction={clickOnAction}
                    onChange={handleTableChange}
                    filterOptionsArr={filterOptionsArr}
                    searchInput={searchInput}
                    onClickSearchItem={onClickSearchItem}
                />
            )}
        </>
    );
};

export default PersonalTrainings;
